import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBillAlt } from "@fortawesome/free-regular-svg-icons";
import { Button } from "reactstrap";

const ErrorZeroBalance = ({ msg, goOrderPayment }) => {
  
  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <i className="far fa-times-circle text-danger" style={{ fontSize: 58 }}></i>
      <span className="mt-2" style={{ fontSize: 20 }}>
        {msg}
      </span>
      <div className="mt-3">
        <Button className="" color="success" onClick={() => goOrderPayment()}>
          <FontAwesomeIcon icon={faMoneyBillAlt} /> Adicionar saldo na conta
        </Button>
      </div>
    </div>
  );
};

export default ErrorZeroBalance;
